<div class="content content--page">
  <div class="content__inner">
    <div class="content__main content__main--page">
      <div class="card card--small">
        <h1 class="card__title">Verify your email</h1>
        <div class="card__content">
          <p><strong>Thank you for upgrading your plan!</strong></p>
          <p>Please log back in to access all the new features</p>
          <a (click)="onDiveIn()" class="button">Log In!</a>
        </div>
      </div>
    </div>
  </div>
</div>
